import React, { useRef, useState } from 'react';
import style from '../css/ContentMaster.module.css';
import MasterItem from './cards/MaterItem';
import line from '../images/line.png';
import Carousel, { consts } from 'react-elastic-carousel';
import contentMaster, { contentMaster2 } from '../utils/contentMaster';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

import decoration1 from '../images/decorations/02.png';
import decoration2 from '../images/decorations/04.png';
import logoUtpl from '../images/UTPL fondo oscuro.png';

const ContentMaster = () => {
	const carousel = useRef(null);
	const [grow, setGrow] = useState(false);
	const [button, setButton] = useState({
		b1: true,
		b2: false,
	});

	const changeButton = (grow, b1, b2) => {
		setGrow(grow);
		setButton({
			b1: b1,
			b2: b2,
		});
	};

	const customArrows = ({ type, onClick, isEdge }) => {
		const pointer = type === consts.PREV ? <IoChevronBack /> : <IoChevronForward />;
		return (
			<button
				onClick={onClick}
				disabled={isEdge}
				style={{
					fontSize: 36,
					border: 'none',
					backgroundColor: 'transparent',
					color: '#6000de',
					position: 'relative',
				}}
			>
				{pointer}
			</button>
		);
	};

	const breakPoints = [
		{ width: 1, itemsToShow: 1 },
		{ width: 560, itemsToShow: 2, itemsToScroll: 1 },
		{ width: 900, itemsToShow: 3, itemsToScroll: 1, showArrows: false },
		{ width: 1200, itemsToShow: 3, itemsToScroll: 1, showArrows: false },
	];

	return (
		<section className={style.master} id='contenido'>
			<div className={style.masterContainer}>
				<div className={style.masterHeader}>
					<h1 className={style.masterTitle}>
						CONTENIDO{' '}
						<span>
							BLENDER
							{/* <img src={line} alt='underline' /> */}
						</span>
					</h1>
					<img src={logoUtpl} alt='logo utpl' className={style.logoUTPL} />
					<p className={style.headerParagraph}>
						Estudia online con FEEDBACK en vivo y en Discord y tendrás cursos PREMIUM de distintos
						niveles <span>por 1 año</span> para que puedas pulir tu técnica.
					</p>
				</div>

				<div className={style.carrouselButtons}>
					<a
						className={button.b1 ? style.carrouselButtonsActive : ''}
						onClick={() => changeButton(false, true, false)}
					>
						{' '}
						STANDARD{' '}
					</a>
					<a
						className={button.b2 ? style.carrouselButtonsActive : ''}
						onClick={() => changeButton(true, false, true)}
					>
						{' '}
						GROW{' '}
					</a>
				</div>

				<div className={style.masterBody}>
					<Carousel
						ref={carousel}
						breakPoints={breakPoints}
						pagination={false}
						renderArrow={customArrows}
						className='master-carousel'
					>
						{grow
							? contentMaster2.map((item, index) => <MasterItem key={index} content={item} />)
							: contentMaster.map((item, index) => <MasterItem key={index} content={item} />)}
					</Carousel>
					<button
						className={`${style.resultsButtons} ${style.masterPrevious}`}
						onClick={() => {
							carousel.current.slidePrev();
						}}
					>
						<IoChevronBack />
					</button>
					<button
						className={`${style.resultsButtons} ${style.masterNext}`}
						onClick={() => {
							carousel.current.slideNext();
						}}
					>
						<IoChevronForward />
					</button>
				</div>
			</div>
		</section>
	);
};

export default ContentMaster;
